import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = controleren, false = niet ingelogd, object = ingelogd

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then((d) => setUser(d.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const d = await api.post("/auth/login", { email, password });
    setUser(d.data);
    return d.data;
  };

  const register = async (name, email, password) => {
    const d = await api.post("/auth/register", { name, email, password });
    setUser(d.data);
    return d.data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const refreshUser = async () => {
    const d = await api.get("/auth/me");
    setUser(d.data);
    return d.data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
